import jss from 'jss';

const styles = {
  table: {
    width: '100%',
    height: '100%'
  }
};

export const { classes } = jss.createStyleSheet(styles).attach();


// WEBPACK FOOTER //
// ./src/views/pending-product-instance/styles/table.js